<template>
  <div v-if="user" class="text-left p-3">
    <div class="h3">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <StatusTag :status="user.get('isActive') ? 'active' : 'inactive'" class="mr-2" />
          <span class="text-uppercase">{{ user.get('username') }}</span>
        </div>
        <div>
          <el-button @click="onResetPassword">
            {{ $t('general.reset_password') }}
          </el-button>
          <el-button :type="statusButtonType" @click="onStatusChange">
            {{ statusButtonText }}
          </el-button>
        </div>
      </div>
    </div>
    <el-divider />
    <el-card>
      <div slot="header" class="font-weight-bold text-left">
        {{ $t('general.general') }}
      </div>
      <table class="el-table">
        <tr>
          <td class="font-weight-bold">
            {{ $t('general.name') }}
          </td>
          <td>{{ `${user.get('firstname')} ${user.get('lastname')}` }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">
            {{ $t('general.company') }}
          </td>
          <td>{{ `${user.get('company')}` }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">
            {{ $t('general.email') }}
          </td>
          <td>{{ `${user.get('email')}` }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">
            {{ $t('general.phone') }}
          </td>
          <td>{{ `${user.get('phone')}` }}</td>
        </tr>
      </table>
    </el-card>
  </div>
</template>

<script>
import StatusTag from '../../../components/atoms/StatusTag';
export default {
  name: 'AdminUserDetailView',
  components: { StatusTag },
  props: {},
  async mounted() {
    let query = new this.$parse.Query(this.$parse.User);
    this.user = await query.get(this.$route.params.id);
  },
  destroyed() {},
  data() {
    return {
      user: null,
    };
  },
  computed: {
    statusButtonText() {
      return this.user.get('isActive') ? 'User deaktivieren' : 'User aktivieren';
    },
    statusButtonType() {
      return this.user.get('isActive') ? 'primary' : 'success';
    },
  },
  methods: {
    async onResetPassword() {
      let modalResult = await this.$bvModal.msgBoxConfirm(this.$t('general.reset_email'), {
        title: this.$t('general.please_confirm'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: this.$t('general.yes'),
        cancelTitle: this.$t('general.no'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      });
      if (modalResult) {
        await this.resetPassword(this.user);
      }
    },
    async resetPassword(user) {
      try {
        let result = await this.$parse.Cloud.run(
          'forgotPassword',
          { email: user.get('email'), origin: this.$clientUrl },
          {}
        );
        this.$message.info(this.$t(result.message));
      } catch (e) {
        this.$message.info(this.$t(e.message));
      }
    },
    async onStatusChange() {
      let message = this.user.get('isActive') ? 'User wirklich deaktivieren?' : 'User wirklich aktivieren?';

      let modalResult = await this.$bvModal.msgBoxConfirm(message, {
        title: this.$t('general.please_confirm'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: this.$t('general.yes'),
        cancelTitle: this.$t('general.no'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      });

      if (modalResult) {
        this.user.set('isActive', !this.user.get('isActive'));
        this.user = await this.user.save();
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
